import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const MessageError = styled.div`
  font-size: 12px;
  margin: 4px 0 0;
  color: ${myPalette.red.main};
`
